import $ from 'jquery';

$(function () {
    const $body = $("body");
    const $bodyHtml = $("body, html");
    const imageBoxErrorClass = "image-box-error";



    $body.on('click',function(event){
        //console.log('',$(event.target),$(event.target).is('span'));
        //console.log(event.target,(!$(event.target).hasClass('multiselect') && !$(event.target).hasClass('checkbox__input') && !$(event.target).hasClass('checkbox__span')));
        if(
            $(event.target).hasClass('multiselect')
            || $(event.target).is('span')
            || $(event.target).hasClass('checkbox__input')
            || $(event.target).hasClass('checkbox__span')
            || $(event.target).hasClass('checkbox')
        ){
            //console.log("don't remove d-block ");
        }else{
            //console.log("remove d-block ");
            $(".buy-dropdown__menu").each(function(){
                $(this).removeClass("d-block");
            })
        }
    })

    $body.on('click', '.multiselect', function () {
        const $currentDropdownMenu = $(this).find(".buy-dropdown__menu");
        $body.find(".buy-dropdown__menu").each((index,element) => {
            if(element !== $currentDropdownMenu.get(0)){
              $(element).removeClass("d-block");
          }
        })
        setTimeout(() => $currentDropdownMenu.toggleClass("d-block"),1)

    });

    /*$body.on("click",function(event) {
        const $target = $(event.target);
        if(!$target.closest('.buy-dropdown__menu').length &&
            $('.buy-dropdown__menu').hasClass("d-block")) {
            $('.buy-dropdown__menu').removeClass("d-block");
        }
    });*/

    $body.on("change",".buy-dropdown__menu input[type=checkbox]",function(){
       $(".buy-dropdown__menu").removeClass("buy-dropdown__menu_error");
    });

    $body.on('click', '#year-select-div', function () {
        $("#month-select-div .options").addClass("options--fade-out");
        $("#day-select-div .options").addClass("options--fade-out");
        $(this).find('.options').toggleClass('options--fade-out');
    });

    $body.on('click', '#month-select-div', function () {
        $("#day-select-div .options").addClass("options--fade-out");
        $("#year-select-div .options").addClass("options--fade-out");
        $(this).find('.options').toggleClass('options--fade-out');
    });
    $body.on('click', '#day-select-div', function () {
        $("#month-select-div .options").addClass("options--fade-out");
        $("#year-select-div .options").addClass("options--fade-out");
        $(this).find('.options').toggleClass('options--fade-out');
    });
    $body.on('click', '.js-find-section-1-quality .btn-third', function () {
        $(".js-find-section-1-quality .image-box").removeClass("image-box-selected").removeClass(imageBoxErrorClass);
        const imageBox = $(this).closest(".image-box");
        imageBox.addClass("image-box-selected");
    });
    $body.on('click', '.find-section-1-where .btn-third', function () {
        $(".find-section-1-where .image-box").removeClass("image-box-selected").removeClass(imageBoxErrorClass);
        const imageBox = $(this).closest(".image-box");
        imageBox.addClass("image-box-selected");
    });
    $body.on('click', '.js-find-section-1-intent .btn-third', function () {
        $(".js-find-section-1-intent .image-box").removeClass("image-box-selected").removeClass(imageBoxErrorClass);
        const imageBox = $(this).closest(".image-box");
        imageBox.addClass("image-box-selected");
    });

    $body.on('change','.js-size-sqm input[type=checkbox]',function(){
        $(".js-size-sqm").find(".checkbox__span").removeClass("checkbox__span_error");
    });
    $body.on('change','.js-size-bedrooms input[type=checkbox]',function(){
        $(".js-size-bedrooms ").find(".checkbox__span").removeClass("checkbox__span_error");
    });

    /*$body.on('click','.own-select',function(){
        $(this).find('.options').toggleClass('options--fade-out');
    })*/

    $body.on('click','#year-select-div .options li',function(e){
        if(!$(this).hasClass("disabled")){
            let content = $(this).html();
            $("#year-select-div .select .label").html(content);
            let selected = null
            $("#year-select-div option").map((index,option) => {
                const optionValue = $(option).val();
                if(optionValue.toString().trim() === content.toString().trim()){
                    selected = $(option);
                }
            } );
            if(!!selected){
                $('#year-select-div option:selected').removeAttr('selected');
                selected.attr("selected","selected");
            }
        }else{
            e.stopPropagation();
        }
    });

    $body.on('click','#month-select-div .options li',function(e){
        if(!$(this).hasClass("disabled")){
            let content = $(this).html();
            $("#month-select-div .select .label").html(content);
            let selected = null
            $("#month-select-div option").map((index,option) => {
                const optionValue = $(option).val();
                if(optionValue.toString().trim() === content.toString().trim()){
                    selected = $(option);
                }
            } );
            if(!!selected){
                $('#month-select-div option:selected').removeAttr('selected');
                selected.attr("selected","selected");
            }
        }else{
            e.stopPropagation();
        }
    });

    $body.on('click','#day-select-div .options li',function(e){
        if(!$(this).hasClass("disabled")){
            let content = $(this).html();
            $("#day-select-div .select .label").html(content);
            let selected = null
            $("#day-select-div option").map((index,option) => {
                const optionValue = $(option).val();
                if(optionValue.toString().trim() === content.toString().trim()){
                    selected = $(option);
                }
            } );
            if(!!selected){
                $('#day-select-div option:selected').removeAttr('selected');
                selected.attr("selected","selected");
            }
        }else{
            e.stopPropagation();
        }
    });


    $body.on("submit", "#find-form", function (event) {
        event.preventDefault();
        const errorClass = "error";
        const checkboxErrorClass = "checkbox__span_error";
        const $gError = $(".g-error");
        const $error = $(".error");

        $gError.addClass("d-none");
        $error.addClass("d-none");


        let hasError = 0;
        /* Check where */
        let whereSelect = null;
        let isDistrictSelect = false;
        const $whereSection = $('#find-section-where');
        const $whereSelectContainer = $(".find-section-1-where .image-box");
        $whereSelectContainer.each(function () {

            if ($(this).hasClass("image-box-selected")) {
                const selectedWhere = $(this).data("value");
                if(selectedWhere === "District"){
                    isDistrictSelect = true;
                    console.log("belép ide?");
                    $(this).find(".buy-dropdown__menu input[type=checkbox]").each(function(){
                        if($(this).prop("checked")){
                            whereSelect = [...whereSelect || [],$(this).val()]
                        }
                    });
                }else{
                    whereSelect = [selectedWhere]
                }

            }
        });
        if (whereSelect === null) {
            if(isDistrictSelect){
                $(".buy-dropdown__menu").addClass("buy-dropdown__menu_error");
            }else{
                $whereSelectContainer.addClass(imageBoxErrorClass);
            }
            $bodyHtml.animate({
                scrollTop: ($whereSection.offset().top )
            } ,1000);
            hasError++;
        }

        /* Check quality */
        let qualitySelect = null;
        const $qualitySection = $('.js-find-section-1-quality');
        const $qualitySelectContainer = $(".js-find-section-1-quality .image-box");
        $qualitySelectContainer.each(function () {

            if ($(this).hasClass("image-box-selected")) {
                qualitySelect = $(this).data("value");
            }
        });
        if (qualitySelect === null) {
            $qualitySelectContainer.addClass(imageBoxErrorClass);
            if(hasError === 0){
                $bodyHtml.animate({
                    scrollTop: ($qualitySection.offset().top )
                } ,1000);
            }
            hasError++;
        }


        /* Check intent */
        let intentSelect = null;
        const $intentSection = $(".js-find-section-1-intent");
        const $intentSelectContainer = $(".js-find-section-1-intent .image-box");
        $intentSelectContainer.each(function () {

            if ($(this).hasClass("image-box-selected")) {
                intentSelect = $(this).data("value");
            }
        });
        if (intentSelect === null) {
            $intentSelectContainer.addClass(imageBoxErrorClass);
            if(hasError === 0){
                $bodyHtml.animate({
                    scrollTop: ($intentSection.offset().top )
                } ,1000);
            }
            hasError++;
        }

       /* Check sqm  selected */
        let checkedSqm = null;
        const $sizeSectionContainer = $(".js-size-sqm");
        $sizeSectionContainer.find("input[type=checkbox]").each(function(){

            if($(this).prop("checked")){
                checkedSqm = [...checkedSqm || [],$(this).data("value")]
            }
        });
        if(checkedSqm === null){
            hasError++;
            $sizeSectionContainer.find(".checkbox__span").addClass(checkboxErrorClass);
        }
        /* Check bedrooms selected */
        let checkedBed = null;
        const $bedSectionContainer = $(".js-size-bedrooms");
        $bedSectionContainer.find("input[type=checkbox]").each(function(){
            if($(this).prop("checked")){
                checkedBed = [...checkedBed || [],$(this).data("value")]
            }
        });
        if(checkedBed === null){
            hasError++;
            $bedSectionContainer.find(".checkbox__span").addClass(checkboxErrorClass);
        }
        /* Textarea */
        const textarea = $("textarea[name='description']");
        let textAreaValue = "";
        //console.log("textarea ", textarea, textarea.val());
        if (textarea.val() === "") {
            textarea.addClass(errorClass);
            hasError++;
        } else {
            textAreaValue = textarea.val();
            textarea.removeClass(errorClass);
        }
        let inputsValue = [];
        /* Check input */
        $("input").each(function(index, input){
            const type = $(this).attr("type");
            if(type !== "checkbox"){
                const $input = $(input);
                if ($input.val() === "" || (type === "email" && !validateEmail($input.val()))) {
                    $input.addClass(errorClass);
                    hasError++;
                } else {
                    $input.removeClass(errorClass);
                    inputsValue = [...inputsValue || [],{
                        [$(this).attr("name")] : $(this).val()
                    }]
                }
            }


            //console.log("input", input);
        });
        if (hasError === 0) {
            /* Remove content */
            $(".find-section").addClass("d-none");
            /* Add loader */
            $(".loader").removeClass("d-none");
            /* Send  ajax requiest for store */

            let sendData = {
                where: whereSelect,
                quality: qualitySelect,
                intent: intentSelect,
                sqm: checkedSqm,
                bed: checkedBed,
                description: textAreaValue,
                lang: $("html").attr("lang"),
                year:$( "#year-select option:selected" ).val(),
                month:$( "#month-select option:selected" ).val(),
                day:$( "#day-select option:selected" ).val(),
            };
            sendData  = Object.assign({}, sendData, ...inputsValue);
            console.log(sendData);
            const url = $(".find-section").data("url");
            $.ajax({
                url: url,
                type: "POST",
                dataType : "json",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(sendData),
                success : function(success) {
                    console.log("success",success);
                    $(".loader").addClass("d-none");
                    $(".success").removeClass("d-none");
                },
                error : function(error) {
                    $(".loader").addClass("d-none");

                    if( typeof  error.responseJSON.errors['g-recaptcha-response'] !== "undefined" ){
                        $gError.removeClass("d-none");
                        $(".error-message").html(error.responseJSON.errors['g-recaptcha-response'][0])
                    }else{
                        $error.removeClass("d-none");
                    }
                    $(".find-section").removeClass("d-none");

                    console.log("error!?",error,error.responseJSON.errors);
                }
            });
        }
    })
});


$(".options").addClass("options--fade-out")


const validateEmail = ($email) =>  {
    let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test( $email );
};
